export class Shiabud {
   Idmafkid:number
    idloan :number
    Amount :number
    Coin :number
}


